module.exports = __webpack_public_path__ + "static/USLPA_Team_Reps_2023-86c912915fdf8e2198c5c54fc77bfead.pdf";